import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';

function useInstallState(install) {
  const ref = useRef(install)
  const [state, setState] = useState(install.state)


  if (ref.current != install) {
    ref.current = install
    setState(install.state)
  }

  useEffect(() => {
    install.on('change', setState)

    return () => {
      install.off('change', setState)
    }
  }, [install])

  return [state, setState]
}


export default useInstallState